import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-users-detail-tabs',
  templateUrl: './users-detail-tabs.component.html',
  styleUrl: './users-detail-tabs.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet],
})
export class UsersDetailTabsComponent implements OnInit {
  protected router = inject(Router);
  private api = inject(ApiService);
  private route = inject(ActivatedRoute);

  navLinks: NavLink[] = [
    {
      label: 'Detalle',
      link: './detail',
    },
    {
      label: 'Reuniones',
      link: './meeting-records',
    },
    {
      label: 'Documentos',
      link: './documents',
    },
  ];

  ngOnInit(): void {
    const userId = this.route.snapshot.paramMap.get('id')!;

    this.api.getUser(userId).subscribe((user: User): void => {
      if (user.role?.slug === 'worker') {
        this.navLinks.push({
          label: 'Planes de carrera',
          link: './career-plans',
        });
      }

      if (user.role?.slug === 'partner') {
        this.navLinks.push({
          label: 'Contratos',
          link: './partner-contracts',
        });
      }
    });
  }
}

interface NavLink {
  label: string;
  link: string;
}
